/* eslint-disable  @typescript-eslint/no-unsafe-return */

export const getEnvironmentVariables = (): Record<
  string,
  string | undefined
> => {
  return {
    ...(typeof process !== 'undefined' ? process.env : {}),
    ...(typeof window !== 'undefined' && (window as any)?.env
      ? (window as any).env
      : {}),
  };
};

export enum Environment {
  LOCAL = 'local',
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
  QA = 'qa',
}

export const getDeploymentEnvironment = (): Environment => {
  const { NEXT_PUBLIC_APP_ENV: env } = getEnvironmentVariables();
  // Direct reference ensures Next.js inlines the value at compile time,
  // as a fallback for when window.env is unavailable (e.g., error/404 pages
  // where the root layout's <script> tag may not execute).
  const resolved =
    env ??
    (typeof process !== 'undefined'
      ? process.env.NEXT_PUBLIC_APP_ENV
      : undefined);

  if (
    !resolved ||
    !Object.values(Environment).includes(resolved as Environment)
  ) {
    throw new Error(
      `NEXT_PUBLIC_APP_ENV must be one of ${Object.values(Environment).join(', ')}; got "${resolved ?? ''}"`,
    );
  }

  return resolved as Environment;
};

export const isProdEnv = (): boolean =>
  getDeploymentEnvironment() === Environment.PROD;
